// extracted by mini-css-extract-plugin
export default {"root":"FavoriteListing_root__K30Wt","error":"FavoriteListing_error__x80Jw"};